import { z } from 'zod';

import { PaginationSchema } from '../../pagination.js';

export const UpsertTenantEnabledFiscalOperationsBodySchema = z.looseObject({
  operationDefinitionCodes: z.array(z.string().min(1).max(50)).min(1),
  disableCodes: z.array(z.string().min(1).max(50)).optional(),
});

export const TenantEnabledFiscalOperationItemSchema = z.looseObject({
  id: z.uuid(),
  operationDefinitionCode: z.string(),
  displayName: z.string().nullable(),
  status: z.string(),
  operationNature: z.string().nullable().optional(),
  direction: z.string().nullable().optional(),
  documentKind: z.string().nullable().optional(),
});

export const ListTenantEnabledFiscalOperationsQuerySchema = PaginationSchema;

export const ListTenantEnabledFiscalOperationsResponseSchema = z.looseObject({
  items: z.array(TenantEnabledFiscalOperationItemSchema),
  pagination: z.looseObject({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export const UpsertTenantEnabledFiscalOperationsResponseSchema =
  ListTenantEnabledFiscalOperationsResponseSchema;

export type UpsertTenantEnabledFiscalOperationsBody = z.infer<
  typeof UpsertTenantEnabledFiscalOperationsBodySchema
>;
export type ListTenantEnabledFiscalOperationsQuery = z.infer<
  typeof ListTenantEnabledFiscalOperationsQuerySchema
>;
